import '@jetbrains/teamcity-ui/index.css'
import * as API from '@jetbrains/teamcity-ui'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as ReactDOMClient from 'react-dom/client'

const TeamCityAPI = {
  ...API,
  React,
  ReactDOM,
  ReactDOMClient,
}

declare global {
  interface Window {
    TeamCityAPI: typeof TeamCityAPI
  }
}
window.TeamCityAPI = TeamCityAPI
